import React from 'react';
import { Link } from 'react-router-dom';
import './Privacy.css'; // reuse same layout styles

export default function DeleteAccount() {
  return (
    <div className="privacy-page">
      <header className="privacy-header">
        <Link to="/" className="back-button">← SafeHer</Link>
        <h1>Delete Your Account</h1>
        <p>How to permanently remove your SafeHer account and data</p>
      </header>

      <div className="privacy-content">

        <h2>How to delete your account</h2>
        <p>
          You can delete your SafeHer account directly from the app or website.
          Your account and personal data are removed immediately and cannot be recovered.
        </p>

        <h2>Steps to delete from the mobile app</h2>
        <ol style={{ paddingLeft: '1.4rem', lineHeight: '2' }}>
          <li>Open the SafeHer app and sign in.</li>
          <li>Tap <strong>Profile</strong> (bottom navigation bar).</li>
          <li>Tap <strong>Delete</strong> in the profile header.</li>
          <li>Optionally tick which community data you also want removed.</li>
          <li>Type <strong>DELETE</strong> in the confirmation field and tap <strong>Delete my account</strong>.</li>
        </ol>

        <h2>Steps to delete from the website</h2>
        <ol style={{ paddingLeft: '1.4rem', lineHeight: '2' }}>
          <li>Go to <a href="https://safeher.xyz">safeher.xyz</a> and sign in.</li>
          <li>Open the <strong>Profile</strong> tab.</li>
          <li>Scroll to the bottom and tap <strong>Delete Account</strong>.</li>
          <li>Optionally tick which community data you also want removed.</li>
          <li>Type <strong>DELETE</strong> to confirm.</li>
        </ol>

        <h2>What is deleted immediately</h2>
        <ul style={{ paddingLeft: '1.4rem', lineHeight: '2' }}>
          <li>Your email address, name, and password</li>
          <li>Your inbox messages</li>
          <li>Your moderator application (if any)</li>
          <li>Your session tokens and login history</li>
        </ul>

        <h2>What you can optionally request deletion of</h2>
        <p>
          At the time of deletion, you can choose to request removal of the following community data.
          By default these are anonymised (no link to your identity) rather than deleted.
        </p>
        <ul style={{ paddingLeft: '1.4rem', lineHeight: '2' }}>
          <li><strong>Your submitted reports</strong> — removed from the map entirely</li>
          <li><strong>Your comments</strong> — removed from all reports</li>
          <li><strong>Your upvotes</strong> — upvote counts on reports adjusted</li>
        </ul>

        <h2>Data deletion timeline</h2>
        <p>
          Personal account data is deleted immediately upon request.
          Community data requested for deletion (reports, comments, upvotes) is fulfilled
          within <strong>90 days</strong>. During this period the data remains anonymised
          with no link to your identity. Anonymised data you did not request deletion of
          may be retained as part of the permanent community safety record.
        </p>

        <h2>Request deletion by email</h2>
        <p>
          If you cannot access the app or website, email{' '}
          <a href="mailto:support@safeher.xyz">support@safeher.xyz</a> from the address
          associated with your account. We will process the request within 7 days.
        </p>

        <h2>Contact</h2>
        <p>
          For any questions about account deletion or your data:{' '}
          <a href="mailto:support@safeher.xyz">support@safeher.xyz</a>
        </p>

        <div className="privacy-last-updated">
          Last updated: June 2026 · SafeHer · <a href="https://safeher.xyz">safeher.xyz</a>
        </div>
      </div>
    </div>
  );
}
